import { render, staticRenderFns } from "./MaterialItem.vue?vue&type=template&id=478637b7"
import script from "./MaterialItem.vue?vue&type=script&lang=js"
export * from "./MaterialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports